import { ModuleInterface, ModuleTypes } from 'components/Modals/Filter/types';
import { config } from 'config/config';

const TYPE_OPTIONS: Record<string, string> = {
    ASSIGNMENT: 'courses.individual_work',
    ASSESSMENT: 'assessment.practical_assessment',
    CERTIFICATE: 'courses.certificate',
};

const STATUS_OPTIONS: Record<string, string> = {
    SUBMITTED: 'grading.pending_grading',
    RETURNED: 'courses.topic_status.submission_returned',
    NOT_SUBMITTED: 'courses.topic_status.not_submitted',
    PASSED: 'courses.topic_status.passed',
    FAILED: 'courses.topic_status.failed',
    MISSED_DEADLINE: 'courses.topic_status.missed_deadline',
    NOT_STARTED: 'student.not_started',
    IN_PROGRESS: 'courses.topic_status.pending_grading',
    FINAL_ASSESSMENT: 'courses.topic_status.final_assessment',
};

const USER_STATUS_OPTIONS: Record<string, string> = {
    ACTIVE: 'user.status.ACTIVE',
    BLOCKED: 'user.status.BLOCKED',
    TEMPORARY_BLOCKED: 'user.status.TEMPORARY_BLOCKED',
};

const PROGRAM_STATUS_OPTIONS: Record<string, string> = {
    COMPLETED: 'grading.program_status_completed',
    NOT_STARTED: 'grading.program_status_not_started',
    FAILED: 'grading.program_status_failed',
    CANCELLED: 'grading.program_status_cancelled',
};

const YES_NO_OPTIONS: Record<string, string> = {
    true: 'general.yes',
    false: 'general.no',
};

/**
 * Filter modules for the grading tabs (Vērtēšana). The "acknowledged"
 * sub-filter only makes sense while acknowledgement_required = Jā.
 */
export const gradingFilterModules = (filter: Record<string, any>): ModuleInterface[] => [
    {
        name: 'program_id',
        label: 'general.learning_program',
        type: ModuleTypes.asyncSelect,
        endpoint: '/api/v1/courses/learning-program/options/list',
        dataKey: 'programs',
        isResponseArray: false,
        localeTranslation: true,
        integerKey: true,
    },
    {
        name: 'organization_uuid',
        label: 'general.organization',
        type: ModuleTypes.asyncSelect,
        endpoint: config.api.routes.backend.selectCustomersUuid,
        dataKey: 'customers',
        isResponseArray: false,
    },
    {
        name: 'type',
        label: 'general.type',
        type: ModuleTypes.select,
        manualOptions: TYPE_OPTIONS,
    },
    {
        name: 'status',
        label: 'general.status',
        type: ModuleTypes.select,
        manualOptions: STATUS_OPTIONS,
    },
    {
        name: 'user_status',
        label: 'users.user_status',
        type: ModuleTypes.checkbox,
        mode: 'multiple',
        manualOptions: USER_STATUS_OPTIONS,
    },
    {
        name: 'program_status',
        label: 'general.program_status',
        type: ModuleTypes.checkbox,
        mode: 'multiple',
        manualOptions: PROGRAM_STATUS_OPTIONS,
    },
    {
        name: 'acknowledgement_required',
        label: 'grading.filter_acknowledgement_required',
        type: ModuleTypes.switch,
        manualOptions: YES_NO_OPTIONS,
    },
    // Switch fields hold booleans; QTable serializes them to 'true'/'false' for the API.
    ...(filter?.acknowledgement_required === true || filter?.acknowledgement_required === 'true'
        ? [
              {
                  name: 'acknowledged',
                  label: 'grading.filter_acknowledged',
                  type: ModuleTypes.switch,
                  manualOptions: YES_NO_OPTIONS,
              },
          ]
        : []),
];
